<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>lock_open</md-icon>
          </div>
          <h4 class="title">Missing Permissions</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-30">
              <md-field>
                <md-input type="text" class="box-textbox" placeholder="Search by email" v-model="email" @keyup.enter="missingPermissionList()"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-30">
              <md-field>
                <md-input type="text" class="box-textbox" placeholder="Search by serial number" v-model="serialNumber" @keyup.enter="missingPermissionList()"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25">
              <md-button class="md-primary" :disabled="isDisabled" @click="missingPermissionList()">
                Search
                <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
              </md-button>
            </div>
          </div>
          <hr />
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Serial Number" md-sort-by="serialNumber">{{ item.serialNumber }}</md-table-cell>
              <md-table-cell md-label="Parent" md-sort-by="email">{{ item.email || "-" }}</md-table-cell>
              <md-table-cell md-label="Status" md-sort-by="kidsApplicationStatus">{{ item.kidsApplicationStatus || "Not reported" }}</md-table-cell>
              <md-table-cell md-label="Reason">{{ formatValue(item.additionalData) }}</md-table-cell>
              <md-table-cell md-label="Error Message">{{ item.errorMessage || "-" }}</md-table-cell>
              <md-table-cell md-label="Enrollment At" md-sort-by="enrollmentTime">{{ item.enrollmentTime ? HumanReadableDateFormat(item.enrollmentTime, true) : "-" }}</md-table-cell>
              <md-table-cell md-label="Last Updated" md-sort-by="updatedAt">{{ item.updatedAt ? HumanReadableDateFormat(item.updatedAt, true) : "-" }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div>
            <p class="card-category">
              Showing {{ total === 0 ? 0 : from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import DeviceDataService from "../../services/SuperAdmin/DeviceDataService";

export default {
  components: {
    Pagination,
  },
  computed: {
    queriedData() {
      return this.sortedData.slice(this.from, this.to);
    },
    sortedData() {
      const sortBy = this.currentSort;
      const dir = this.currentSortOrder === "desc" ? -1 : 1;
      return [...this.tableData].sort((a, b) => {
        const x = a[sortBy] == null ? "" : String(a[sortBy]);
        const y = b[sortBy] == null ? "" : String(b[sortBy]);
        return x.localeCompare(y) * dir;
      });
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      return this.total < highBound ? this.total : highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.tableData.length;
    },
  },
  data() {
    return {
      isDisabled: false,
      currentSort: "updatedAt",
      currentSortOrder: "desc",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      tableData: [],
      serialNumber: "",
      email: "",
    };
  },
  methods: {
    // Sorting is handled in the sortedData computed, so just return the value unchanged
    customSort(value) {
      return value;
    },
    formatValue(val) {
      if (val === null || val === undefined || val === "") return "-";
      return typeof val === "object" ? JSON.stringify(val) : val;
    },
    missingPermissionList() {
      this.isDisabled = true;
      const data = { email: this.email, serialNumber: this.serialNumber };
      DeviceDataService.missingPermissionList(data)
        .then((response) => {
          this.isDisabled = false;
          this.tableData = response.data.data;
          this.pagination.currentPage = 1;
        })
        .catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  mounted() {
    this.missingPermissionList();
  },
};
</script>

<style scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: top;
}
</style>